<template>
  <b-modal id="modal-selecao-caracteristicas" size="lg" :title="$t('header.selecionar-caracteristicas')" centered>      
    <b-card bg-variant="light" :header="$t('header.selecionar-caracteristicas')" style="height:100%">
      <b-row align-h="between">        
        <b-col cols="auto">
          <b-button-group size="sm">
            <b-button :title="$t('botoes.selecionar-todos')">
              <b-icon icon="check-square" aria-hidden="true" @click="selectAllRowsCaracteristicas"></b-icon>
            </b-button>
            <b-button :title="$t('botoes.limpar-selecao')">
              <b-icon icon="square" aria-hidden="true" @click="clearSelectedCaracteristicas"></b-icon>
            </b-button>
          </b-button-group>
        </b-col>
      </b-row>
      <b-table v-if="caracteristicas.length > 0" :items="caracteristicas" :fields="fieldsCaracteristicas"
        select-mode="range" responsive="sm" ref="selectableTableCaracteristicas" selectable bordered hover small
        center :current-page="currentPageCaracteristicas" :per-page="perPageCaracteristicas"
        class="table-controles text-center mt-2 table-wrapper" head-variant="light"
        @row-selected="onRowSelectedCaracteristicas">
      </b-table>

      <b-row>
        <b-col>
          <b-pagination v-model="currentPageCaracteristicas" :total-rows="caracteristicas.length"
            :per-page="perPageCaracteristicas" align="fill" size="sm" class="my-0"></b-pagination>
        </b-col>
      </b-row>
    </b-card>

    <template #modal-footer>
      <b-button size="sm" @click="adicinarCaracteristicas" :disabled="selectedCaracteristicas.length == 0">
            <b-icon icon="plus"></b-icon>
            {{ $t("botoes.adicionar") }}
          </b-button>      
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalSelecaoCaracteristicas',
  props: {
    caracteristicas: {
      type: Array,
      default: () => []
    },
    relatorioId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      totalRowsCaracteristicas: 1,
      currentPageCaracteristicas: 1,
      perPageCaracteristicas: 15,
      fieldsCaracteristicas: ["elemento", "ax"],
      selectedCaracteristicas: []
    };
  },
  methods: {
    abrirModal() {
      this.$bvModal.show("modal-selecao-caracteristicas");
    },
    fecharModal() {
      this.$bvModal.hide("modal-selecao-caracteristicas");
    },
    adicinarCaracteristicas() {
      this.$emit('adicionar-caracteristicas', this.selectedCaracteristicas);
      this.clearSelectedCaracteristicas();
      this.fecharModal();
    },
    onRowSelectedCaracteristicas(items) {
      this.selectedCaracteristicas = items;
    },
    selectAllRowsCaracteristicas() {
      this.$refs.selectableTableCaracteristicas.selectAllRows();
    },
    clearSelectedCaracteristicas() {
      this.$refs.selectableTableCaracteristicas.clearSelected();
    }
  }
};
</script>

<style scoped>
.table-wrapper {
  font-size: 12px !important;
}
</style>